module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm7.984 17c0 .552-.432 1-.984 1h-7.016v3.064c0 .932-.374 1.214-1.174.632l-6.248-4.644c-.8-.58-.728-1.526.072-2.108l6.14-4.644c.804-.582 1.21-.296 1.21.634V14H23c.552 0 .984.448.984 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-circle-3.js
// module id = 1222
// module chunks = 14